module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav"
  }, [
    [_c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.tableData,
        "stripe": "",
        "header-cell-style": _vm.tableHeaderColor
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "medicineName",
        "label": "药品名称",
        "width": "200px"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "manufacturer",
        "label": "产地"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "unit",
        "label": "单位"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "number",
        "label": "库存数量"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "actualNumber",
        "label": "实际数量"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var row = ref.row;

          return [_c('el-input', {
            on: {
              "input": function($event) {
                return _vm.handleInNumberChange(row.id, $event, row)
              }
            },
            model: {
              value: (row.actualNumber),
              callback: function($$v) {
                _vm.$set(row, "actualNumber", $$v)
              },
              expression: "row.actualNumber"
            }
          })]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "盘盈盘亏",
        "prop": "diffNumber"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var row = ref.row;

          return [_vm._v("\n                    " + _vm._s(row.diffNumber) + "\n                ")]
        }
      }])
    })], 1)], _vm._v(" "), _c('div', {
      staticClass: "block"
    }, [_c('el-pagination', {
      attrs: {
        "small": "",
        "current-page": _vm.currentPage,
        "page-size": this.Size,
        "layout": "total,prev, pager, next, jumper",
        "total": this.total
      },
      on: {
        "size-change": _vm.handleSizeChange,
        "current-change": _vm.handleCurrentChange,
        "update:currentPage": function($event) {
          _vm.currentPage = $event
        },
        "update:current-page": function($event) {
          _vm.currentPage = $event
        }
      }
    })], 1), _vm._v(" "), _c('el-row', {
      staticStyle: {
        "margin": "10px 0px"
      }
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.add
      }
    }, [_vm._v("保存")]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": "./checkStock"
      }
    }, [_c('el-button', {
      attrs: {
        "type": "info",
        "plain": ""
      },
      on: {
        "click": function($event) {
          _vm.back(_vm.localStorage.removeItem('editTable'))
        }
      }
    }, [_vm._v("返回")])], 1)], 1)
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47958e30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/pharmacy/details.vue
// module id = 1016
// module chunks = 2